import React from 'react';

import {
    Box,
    IconButton,
    useBreakpointValue,
    Stack,
    Heading,
    Container,
} from '@chakra-ui/react';
// Here we have used react-icons package for the icons
import { BiLeftArrowAlt, BiRightArrowAlt } from 'react-icons/bi';
// And react-slick as our Carousel Lib
import Slider from 'react-slick';

// Settings for the slider
const settings = {
    dots: true,
    arrows: false,
    fade: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
};

export const Tools = () => {
    // As we have used custom buttons, we need a reference variable to
    // change the state
    const [slider, setSlider] = React.useState(null); //<Slider | null>

    // These are the breakpoints which changes the position of the
    // buttons as the screen size changes
    const top = useBreakpointValue({ base: '90%', md: '50%' });
    const side = useBreakpointValue({ base: '30%', md: '40px' });

    // This list contains all the data for carousels
    // This can be static or loaded from a server
    const tools = [
        {
            title: 'GitHub',
            image:
                'https://upload.wikimedia.org/wikipedia/commons/c/c2/GitHub_Invertocat_Logo.svg',
        },
        {
            title: 'VS Code',
            image:
                'https://code.visualstudio.com/assets/branding/app-icon.png',
        },
        {
            title: 'netlify',
            image:
                'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvzmMIm-LMkKbCtGEKYnyaTpg-DH1H_EkAzoS_7aaUPYenVfg8dMcnt4YLuMsqmJeJ8WjvpeK7J7o&usqp=CAU&ec=48665701',
        },
        {
            title: 'POSTMAN',
            image:
                'https://img-c.udemycdn.com/course/240x135/1159824_3226_4.jpg',
        },

    ];

    return (
        <Box m={"50px"}>
            <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}>
                Tools
            </Heading>
            <Box
                position={'relative'}
                height={'700px'}
                width={'full'}
                overflow={'hidden'}>
                {/* CSS files for react-slick */}
                <link
                    rel="stylesheet"
                    type="text/css"
                    charSet="UTF-8"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
                />
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
                />
                {/* Left Icon */}
                <IconButton
                    aria-label="left-arrow"
                    variant="ghost"
                    position="absolute"
                    left={side}
                    top={top}
                    transform={'translate(0%, -250%)'}
                    zIndex={2}
                    onClick={() => slider?.slickPrev()}>
                    <BiLeftArrowAlt size="40px" />
                </IconButton>
                {/* Right Icon */}
                <IconButton
                    aria-label="right-arrow"
                    variant="ghost"
                    position="absolute"
                    right={side}
                    top={top}
                    transform={'translate(0%, -250%)'}
                    zIndex={2}
                    onClick={() => slider?.slickNext()}>
                    <BiRightArrowAlt size="40px" />
                </IconButton>
                {/* Slider */}
                <Slider {...settings} ref={(slider) => setSlider(slider)}>
                    {tools.map((tools, index) => (
                        <Box
                            key={index}
                            height={'s'}
                            position="relative"
                            backgroundPosition="center"
                            backgroundRepeat="no-repeat"
                            backgroundSize="300px"
                            backgroundImage={`url(${tools.image})`}
                        >
                            {/* This is the block you need to change, to customize the caption */}
                            <Container size="container.lg" height="500px" position="relative">
                                <Stack
                                    spacing={6}
                                    w={'full'}
                                    maxW={'lg'}
                                    position="absolute"
                                    top="85%"
                                    transform="translate(0, -50%)">
                                    <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}>
                                        {tools.title}
                                    </Heading>
                                </Stack>
                            </Container>
                        </Box>
                    ))}
                </Slider>
            </Box>
        </Box>
    );
}